function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "szuflada",
  transform: "translate(0 0.01)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2277",
  "data-name": "Path 2277",
  d: "M13.78,5.1H1.22A1.23,1.23,0,0,0,0,6.33v7.44A1.23,1.23,0,0,0,1.22,15H13.78A1.23,1.23,0,0,0,15,13.77V6.33A1.23,1.23,0,0,0,13.78,5.1ZM14,13.77a.22.22,0,0,1-.22.22H1.22A.22.22,0,0,1,1,13.77V6.33a.22.22,0,0,1,.22-.22H13.78a.22.22,0,0,1,.22.22Z",
  fill: "fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2278",
  "data-name": "Path 2278",
  d: "M10.57,9a.51.51,0,0,0-.5.51v.72a.59.59,0,0,1-.59.59h-4a.59.59,0,0,1-.59-.59V9.55A.51.51,0,0,0,4.43,9a.5.5,0,0,0-.5.51v.72a1.6,1.6,0,0,0,1.59,1.6h4a1.6,1.6,0,0,0,1.59-1.6V9.55A.5.5,0,0,0,10.57,9Z",
  fill: "fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2279",
  "data-name": "Path 2279",
  d: "M2.49,3.53h9.37a.51.51,0,0,0,.5-.51.5.5,0,0,0-.5-.5H2.49a.505.505,0,0,0,0,1.01Z",
  fill: "fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2280",
  "data-name": "Path 2280",
  d: "M4,1h6.37a.51.51,0,0,0,.5-.51.51.51,0,0,0-.5-.5H4A.51.51,0,0,0,4,1Z",
  fill: ""
}));

function SvgIconDrawer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.01,
    viewBox: "0 0 15 15.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrawer);
export default __webpack_public_path__ + "static/media/icon_drawer.c88a2209.svg";
export { ForwardRef as ReactComponent };